import { useState, useEffect, useRef, useCallback } from 'react';

// ============================================================================
// HELPER: Debounce simple sin dependencias externas
// ============================================================================
const useDebounce = (callback, delay) => {
  const timeoutRef = useRef(null);

  const debounced = useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);

  return debounced;
};

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
};

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  // ========================================================================
  // OPTIMIZACIÓN: Debounce de 150ms para evitar cientos de renders
  // El listener se ejecuta muy frecuentemente durante resize
  // ========================================================================
  const handleResize = useDebounce(() => {
    setWindowDimensions(getWindowDimensions());
  }, 150);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return windowDimensions;
};

export default useWindowDimensions;
